<template>
  <div></div>
</template>

<script>
import { Loading } from 'element-ui';
import constants from '@/utils/constants';
import accountService from '@/api/accountService';

export default {
  name: 'account',
  data() {
    return {
      loading: null,
      error: false
    };
  },
  mounted() {
    this.loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
    this.validateEmail();
    this.loading.close();
  },
  methods: {
    async validateEmail() {
      const { email } = this.$route.query;

      if (!email) {
        this.loading.close();
        this.$message.error('Email is required to activate your account. Please provide an email address.');
        setTimeout(() => {
          this.$router.push('/home/index');
        }, 3000);

        return;
      }
      accountService.activateEmail(email)
        .then(() => {
          this.$message.success('Email activated successfully!');
        }).catch((error) => {
          this.error = true;
          this.$message.error(error.message || 'Failed to activate email. Please try again later.');
        })
        .finally(() => {
          this.loading.close();
          if (this.error) {
            this.$message.error('There was an error activating your email. Please try again later.');
          } else {
            this.$message.success('Your email has been successfully activated!');
          }
          setTimeout(() => {
            this.$router.push('/home/index');
          }, 3000);
        });
    }
  }
};
</script>
